import React, { useState, useRef } from 'react';
import classnames from 'classnames';
import Button from '../../audi-ui-components/Button';
import Thumbnail from '../../components/Thumbnail';
import {
  PRIZE_DRAW_ACTIVE,
  PRIZE_DRAW_CLOSED,
  PRIZE_DRAW_BROKEN,
  PRIZE_DRAW_DRAWN,
  PRIZE_DRAW_SOLD_OUT,
  PRIZE_DRAW_NO_RAFFLE
} from '../../constants';

const PrizeDetails = ({ status, prizes = [] }) => {
  
  const [expanded, setExpanded] = useState(false);
  const [expanding, setExpanding] = useState(false);
  
  const prizesTop = useRef(null);
  
  const onExpandClick = () => {
    let rect = prizesTop.current ? prizesTop.current.getBoundingClientRect() : {};
    let top = rect.top + window.scrollY;
    window.scrollTo({top: top - 119, behaviour: 'smooth'});
    if (expanded) {
      setExpanded(false);
      setExpanding(true);
      setTimeout(() => { setExpanding(false); }, 200);
    } else {
      setExpanding(true);
      setTimeout(() => { setExpanded(!expanded); setExpanding(false); }, 500);
    }
  }
  
  const isOpen = status === PRIZE_DRAW_ACTIVE;
  const isDrawn = status === PRIZE_DRAW_DRAWN;

  if (!isOpen && !isDrawn) { return null; }

  return (
    <div className="prize-details mt-2">
      
      {prizes.length === 1 && <div className="row">
        <div className="col-small-2">&nbsp;</div>
        <div className="prize-major col-small-8">
          {isOpen && <Thumbnail title={prizes[0].title} hasHtmlTitle thumbnail={prizes[0].prizeImageUrl} description={prizes[0].description} />}
          {isDrawn && <Thumbnail thumbnail={prizes[0].prizeWinnerImageUrl} description={prizes[0].prizeWinnerDetails} />}
        </div>
      </div>}
        
      {prizes.length > 1 && <div className="row">
        <div className="prize-major col-small-6 pb-3 pb-small-0">
          {isOpen && <Thumbnail title={prizes[0].title} hasHtmlTitle thumbnail={prizes[0].prizeImageUrl} description={prizes[0].description} />}
          {isDrawn && <Thumbnail thumbnail={prizes[0].prizeWinnerImageUrl} description={prizes[0].prizeWinnerDetails} />}
        </div>
        <div className="prize-major col-small-6 pb-3 pb-small-0">
          {isOpen && <Thumbnail title={prizes[1].title} hasHtmlTitle thumbnail={prizes[1].prizeImageUrl} description={prizes[1].description} />}
          {isDrawn && <Thumbnail thumbnail={prizes[1].prizeWinnerImageUrl} description={prizes[1].prizeWinnerDetails} />}
        </div>
      </div>}
        
      <div ref={prizesTop}></div>
      {prizes.length > 2 && <div className={classnames("prizes-secondary", {"expanded": (expanded || entryClosed || isDrawn), "expanding": expanding})}>
        <div className="row">
          {prizes.slice(2).map((prize,i) => (
            <div className="col-small-4 pb-3 pb-small-0" key={`prize${i}`}>
              {isOpen && <Thumbnail title={prize.title} hasHtmlTitle thumbnail={prize.prizeImageUrl} description={prize.description} />}
              {isDrawn && <Thumbnail thumbnail={prize.prizeWinnerImageUrl} description={prize.prizeWinnerDetails} />}
            </div>
          ))}
        </div>
        {!(isDrawn || entryClosed) && <div className="text-center my-2">
          <Button variant="secondary" onClick={onExpandClick}>{expanded ? 'Hide all prizes' : 'View all prizes'}</Button>
        </div>}
      </div>}
      
    </div>
  );
}

export default PrizeDetails;
